<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-form
                ref="form_all"
                v-model="valid.all"
              >
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Параметры
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-domain
                    </v-icon>Права доступа
                  </v-tab>

                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.name"
                          outlined
                          label="Наименование"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-autocomplete
                          v-if="$store.state.access[15][5]"
                          v-model="form.client"
                          clearable
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Наименование клиента"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                          outlined
                          @change="client_selected"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel
                            v-for="(item,i) in dict.entity"
                            v-if="access.filter(a=>a.entity == i)[0]"
                            :key="i"
                          >
                            <v-expansion-panel-header v-if="access.filter(a=>a.entity == i)[0]">
                              {{ item }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content v-if="access.filter(a=>a.entity == i)[0]">
                              <v-row
                                v-for="(item,j) in dict.terminal_type"
                                v-if="i == 34"
                                :key="j"
                              >
                                <v-checkbox
                                  v-if="access.filter(a=>a.entity == i && a.type == j)[0]"
                                  v-model="form.accesses[i]"
                                  :value="Number(j)"
                                  :label="item"
                                />
                              </v-row>
                              <v-row
                                v-for="(item,j) in reminderEvent()"
                                v-if="i == 35"
                                :key="j"
                              >
                                <v-checkbox
                                  v-if="access.filter(a=>a.entity == i && a.type == j)[0]"
                                  v-model="form.accesses[i]"
                                  :value="Number(j)"
                                  :label="item"
                                />
                              </v-row>
                              <v-row
                                v-for="(item,j) in dict.type"
                                v-if="i != 35 && i!=34"
                                :key="j"
                              >
                                <v-checkbox
                                  v-if="access.filter(a=>a.entity == i && a.type == j)[0]"
                                  v-model="form.accesses[i]"
                                  :value="Number(j)"
                                  :label="item"
                                />
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              md="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Отмена</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              md="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                :disabled="!valid.all"
                @click="save"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import { ReminderEvent } from "@/views/reminder/models/reminder.model"
  export default {
    data: () => ({
        search: {
        client: {
          loading: false,
          text: ''
        },
        },
        access: [],
        validations: {
            valid: {
            form: false
            },
            rules: {
            required: [
                value => !!value || value === false || 'Обязательное поле.'
            ],
            required_date: [
                value => !!value || value === false || 'Обязательное поле.',
                value => moment(value) <= moment() || 'Некорректная дата'
            ],
            max_date: [
                value => !value || moment(value) <= moment() || 'Некорректная дата'
            ],
            name_rules: [
                value => !!value || 'Обязательное поле.',
                value => (value || '').length >= 2 || 'Минимум 2 символа',
                value => (value || '').length <= 25 || 'Максимум 25 символа',
                value => {
                const pattern = /^[a-zA-Zа-яА-ЯёЁ\-]+$/
                return pattern.test(value) || 'Недопустимые символы'
                }
            ],
            email_rules: [
                value => !!value || 'Обязательное поле',
                value => (value || '').length <= 30 || 'Максимум 30 символов',
                value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Недопустимая почта'
                },
            ]
        }
      },
        valid: {
            all: false
        },
      profile: false,
      password: {
          show1: false,
          show2: false
      },
      form: {
          name: '',
          accesses: {}
      },
      select: {
          clients: []
      },
      dict: {
          entity: {
              0: 'Пользователи',
              1: 'Справочники',
              2: 'Клиенты',
              3: 'События',
              4: 'Договора',
              5: 'Логи',
              6: 'Настройка доступа',
              7: 'Настройки системы',
              8: 'Таблицы',
              9: 'Записи',
              10: 'Документы',
              11: 'Папки',
              12: 'Места обслуживания',
              13: 'Каталог устройств',
              14: 'Список оборудования',
              15: 'Точки',
              16: 'Операторы',
              17: 'Получатели',
              18: 'Услуги и товары',
              19: 'Заказы',
              20: 'Платежи',
              21: 'Фискальные операции',
              22: 'Плательщики',
              23: 'Роль',
              34: 'Терминал',
              35: 'Настройки уведомлений',
              36: 'Уведомления'
          },
          type: {
              0: 'Открыть страницу',
              1: 'Просмотр всех записей',
              2: 'Просмотр своих записей',
              3: 'Изменение',
              4: 'Изменение своих записей',
              5: 'Создание',
              6: 'Ограниченное создание'
          },
          terminal_type: {
              0: "Выйти из приложения",
              1: "Сверка итогов",
              2: "Сброс сессии",
              3: "Переключить точку",
              4: "DataPhone - получение настроек",
              5: "DataPhone - тестовая оплата",
              6: "Создать задачу на отмену последней операции",
              7: "Принудительный переход на экран вендинга",
              8: "REMOTE VEND",
              9: "Управление реле",
              10: "Статус датчиков",
            11: "Добавить карту доступа",
            12: "Открыть дверь"
          },
      }
    }),
    computed: {
        max_date: function () {
            return moment().format('YYYY-MM-DD')
        },
    },
    watch: {
        'search.client.text': function () {
            if (this.search.client.text) { this.load_clients(this.search.client.text) }
        },
    },
    mounted: function () {
      this.form.client = localStorage.getItem("client") || ''
      var id = this.$route.query.id
      if (id) { this.load(id) } else this.load_accesses()
      if (this.form.client) {
        this.load_clients_id(this.form.client)
      }
    },
    methods: {
        client_selected: function () {
            this.axios.post('/api/equipment/list', {
                client: this.form.client,
                free: true
            })
                .then(result => {
                    if (!result.data.error) {
                        this.select.equipment = result.data.data
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            this.axios.post('/api/user/list', { client: this.form.client })
                .then(result => {
                    if (!result.data.error) {
                        this.select.user = []
                        for (const x in result.data.data) {
                            this.select.user.push({
                                value: result.data.data[x],
                                text: result.data.data[x].surname + ' ' + result.data.data[x].name + ' ' + result.data.data[x].patronymic
                            })
                        }
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            this.axios.post('/api/place/list', {
                client: this.form.client
            })
                .then(result => {
                    if (!result.data.error) {
                        this.select.place = result.data.data
                        for (const x in this.select.place) {
                            this.select.place[x].name_full = this.select.place[x].name + '| ' + this.select.place[x].address
                        }
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            this.axios.post('/api/configuration/list', {
                client: this.form.client
            })
                .then(result => {
                    if (!result.data.error) {
                        this.select.configurations = result.data.data
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            this.axios.post('/api/sbpprofile/list', {
                client: this.form.client
            })
                .then(result => {
                    if (!result.data.error) {
                        this.select.sbpprofile = result.data.data
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            this.axios.post('/api/device/list', {
                client: this.form.client
            })
                .then(result => {
                    if (!result.data.error) {
                        this.select.device = result.data.data
                        for (const x in result.data.data) {
                            this.dict.device[result.data.data[x].id] = result.data.data[x].model
                        }
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        client_filter: function (item, query, text) {
            if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            return false
        },
        load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
            this.client_selected()
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
        load_accesses: function () {
        this.axios.post('/api/access/list')
          .then(response => {
            if (!response.data.error) {
              this.access = response.data.data.filter(a => a.roles.indexOf(2) > -1)
              for (const x in this.access) {
                  if (!this.form.accesses[this.access[x].entity]) { this.form.accesses[this.access[x].entity] = [0, 1, 2, 3, 4, 5, 6] }
              }
            } else {
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      load: function (id) {
        this.axios.post('/api/role/list', { id: id })
          .then(response => {
            if (!response.data.error) {
                this.form = response.data.data[0]
                this.load_accesses()
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      save: function () {
          let url = '/api/role/save'
          if (!this.form.id) {
              url = '/api/role/create'
          }
          this.axios.post(url, this.form)
          .then(response => {
            if (!response.data.error) {
              this.$router.go(-1)
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', e)
          })
      },
      reminderEvent () {
        return ReminderEvent.map(m => m.text)
      },
    },
  }
</script>
